<template>
  <router-link
    class="article-list-item"
    :to="'/Article/'+article.id"
    tag="div"
  >
    <div v-if="article.section" class="tag">
      <van-tag
        round
        color="#ffedeb"
        text-color="#f15f5f"
      >
        #
      </van-tag>
      {{ article.section.name }}
    </div>
    <div class="abstract">
      <van-image
        v-if="article.abbrImageId"
        width="100%"
        height="150"
        fit="cover"
        :src="abbrImageSrc"
        class="avatar"
      >
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
      <template v-else>
        <div class="content-wrap">
          <article-content :content="article.content" />
        </div>
        <div class="content-fadeout" />
      </template>
    </div>
    <div class="title">
      {{ article.title }}
    </div>
    <div class="info">
      <span class="publisher">
        <van-icon class-prefix="iconfont" name="person" />
        {{ article.publisherName }}
      </span>
      <span class="publish-time">
        <van-icon class-prefix="iconfont" name="clock" />
        {{ article.publishTime|shortDate }}
      </span>
      <span class="read-count">
        <van-icon class-prefix="iconfont" name="attention" size="18px" />
        {{ article.readCount }}
      </span>
    </div>
  </router-link>
</template>

<script>
import { formatDate } from '@/utils'
import ArticleContent from '../ArticleContent'

export default {
  components: {
    ArticleContent
  },
  filters: {
    shortDate: function(dateString) {
      return formatDate(new Date(dateString), 'yyyy-MM-dd')
    }
  },
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    abbrImageSrc() {
      return `${process.env.VUE_APP_RECSS_BASE_API}/ArticleAttach/${this.article.abbrImageId}/File`
    }
  }
}
</script>

<style scoped lang="scss">
.article-list-item {
  border-radius: 4px;
  margin: 10px 10px 0px 10px;
  padding: 10px;
  background-color: #ffffff;
  box-shadow: 0px 2px 3px #bcbcbc;
  font-size: 15px;
  .tag {
    position: relative;
    z-index: 999;
    height: 24px;
    line-height: 24px;
    margin-bottom: -12px;
    padding: 0 10px 0 5px;
    background-color: #ffffff;
    border-radius: 0 12px 12px 0;
    float: left;
    box-shadow: 1px 0px 3px #bcbcbc;
    .van-tag {
      font-weight: 700;
    }
  }
  .abstract {
    .content-wrap {
      width: 100%;
      height: 150px;
      overflow: hidden;
      background-color: #f8f8f8;
      .article-content {
        padding: 10px;
      }
    }
    .content-fadeout {
      position: relative;
      z-index: 999;
      height: 150px;
      margin-top: -150px;
      background-image: linear-gradient(
        -180deg,
        rgba(255, 255, 255, 0) 0%,
        #f8f8f8 90%
      );
    }
  }
  .title {
    color: #333;
    widows: 100%;
    line-height: 24px;
    font-weight: 700;
  }
  .info {
    color: #888;
    font-size: 12px;
    line-height: 22px;
    .publisher {
      .iconfont {
        vertical-align: -1px;
      }
    }
    .publish-time {
      margin-left: 10px;
      .iconfont {
        vertical-align: -1px;
      }
    }
    .read-count {
      float: right;
      .iconfont {
        vertical-align: -2px;
      }
    }
  }
}
</style>
